/* import __COLOCATED_TEMPLATE__ from './white-header-title.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();